import { render, staticRenderFns } from "./CheatingCheckForm.vue?vue&type=template&id=28deb94a&scoped=true"
import script from "./CheatingCheckForm.vue?vue&type=script&lang=js"
export * from "./CheatingCheckForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28deb94a",
  null
  
)

export default component.exports